import React from 'react'
import { SidebarMenu } from '../../components'

const menu = [
  {
    title: 'Publishing Groups',
    href: '/settings/groups?tab=groups',
  },
  {
    title: 'Capabilities',
    href: '/settings/capabilities?tab=all-capabilities',
  },
  {
    title: 'Media Types',
    href: '/settings/media-types?tab=all-types',
  },
  {
    title: 'Media Type Groups',
    href: '/settings/media-type-groups?tab=all-groups',
  },
]

export const SettingsMenu = (props: any) => (
  <SidebarMenu caption="Settings" menu={menu} />
)
